<div class="container mt-5">
  <app-register-stepper [progressData]="getProgressData()" [user]="user"></app-register-stepper>

  <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">{{ alert.message }}</ngb-alert>
  <ngb-alert *ngIf="showRehomeAlert" [type]="'danger'" (closed)="showRehomeAlert = false" class="sticky-top" style="top: 10px;">
    It looks like your pet’s already registered. If you’re the new keeper, please request a transfer of keepership by
    <a href="javascript:void(0)" (click)="openRehomeModal()" class="alert-link">clicking here</a>.<br>
  </ngb-alert>
  <ngb-alert *ngIf="showVetCodeAlert" [type]="'danger'" (closed)="showVetCodeAlert = false" class="sticky-top" style="top: 10px;">
    We weren't able to recognise the vetcode you entered. If you don't know your vetcode
    <a href="javascript:void(0)" (click)="toggleSkipVetCode()" class="alert-link">click here</a>.<br>
  </ngb-alert>

  <div class="row mb-5">
    <div class="col-12">
      <h1 class="text-center">
        Your pet’s details
      </h1>
    </div>
  </div>

  <div class="row mb-5">
    <div class="col-12 mb-3">

      <form
        #chipDetailsForm="ngForm"
        (ngSubmit)="next()"
        novalidate>

        <div class="row mb-3">
          <div class="col-12 col-md-8 col-lg-4 offset-md-2 offset-lg-4">

            <div class="mb-3">
              <label class="form-label" for="chipNumber">
                Chip number
              </label>
              <input
                #chipNumber="ngModel"
                class="form-control"
                [class.is-invalid]="chipNumber.touched && !chipNumber.valid"
                id="chipNumber"
                name="chipNumber"
                [(ngModel)]="model.chipNumber"
                placeholder="Chip number"
                required
                type="text"/>
              <div
                *ngIf="chipNumber.errors && chipNumber.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
              <!-- <div
                *ngIf="chipNumber.errors && chipNumber.errors.minlength"
                class="invalid-feedback">
                {{ errorStrings.chipNumberInvalid }}
              </div> -->
            </div>

            <div
              *ngIf="!model.vetCodeSkipped"
              class="mb-3">
              <label class="form-label" for="vetCode">
                Vet code
              </label>
              <input
                #vetCode="ngModel"
                class="form-control"
                [class.is-invalid]="vetCode.touched && !vetCode.valid"
                id="vetCode"
                name="vetCode"
                [(ngModel)]="model.vetCode"
                placeholder="Vet code"
                required
                type="text"/>
              <div
                *ngIf="vetCode.errors && vetCode.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
              <!-- <div
                *ngIf="vetCode.errors && vetCode.errors.minlength"
                class="invalid-feedback">
                {{ errorStrings.vetCodeInvalid }}
              </div> -->
            </div>

            <div>
              <button type="button"
                      class="btn btn-link p-0"
                      (click)="toggleSkipVetCode()">
                <fa-icon
                  class="me-2"
                  [icon]="['far', model.vetCodeSkipped ? 'square-check' : 'square']">
                </fa-icon>I don't know my vetcode
              </button>
            </div>

          </div>
        </div>

        <div class="row">

          <!-- <div class="col-12 col-md-6 col-lg-4 offset-lg-2"> -->
          <div class="col-12 col-md-8 col-lg-4 offset-md-2 offset-lg-4">
            <button
              type="submit"
              class="btn btn-success text-white btn-lg w-100 mt-5"
              [disabled]="!chipDetailsForm.valid || loading">
              <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
              {{ loading ? 'Saving' : 'Next' }}
            </button>
          </div>

          <!-- <div class="col-12 col-md-6 col-lg-4">
            <button
              type="button"
              class="btn btn-dark btn-lg w-100 mt-5"
              routerLink="/claim-pet/by-phone"
              (click)="trackEvent('registerchip::chipvetcode::notonhand::clicked')">
              I don't have this
            </button>
          </div> -->

        </div>

      </form>

    </div>
  </div>

</div>
